<section class="chat-languages">
  <!-- dialog header -->
  <div class="chat-languages__header">
    <!-- title -->
    <h4 class="chat-languages__title">{{ '' | translate }}</h4>
    <!-- close button -->
    <i
      class="iconsax chat-languages__close-icon"
      icon-name="x"
      (click)="close()"></i>
  </div>

  <!-- search language field -->
  <pwj-input
    class="chat-languages__search-input"
    (input)="onSearchLanguage($event)"
    placeholder="global.search"
    icon="search-normal-2"></pwj-input>

  <!-- languages list -->
  <ul class="chat-languages__content custom-scrollbar">
    @for (lang of languageCodes; track $index) {
      <li class="chat-languages__item">
        <!-- language button -->
        <button
          class="chat-languages__button"
          [ngClass]="{
            'chat-languages__button--selected':
              currentChatLang === lang?.lang_iso_code
          }"
          (click)="onSelectLanguage(lang.lang_iso_code)">
          <!-- language icon -->
          <i
            [class]="
              'country-icon lang-flags lang-flag:' + lang?.lang_iso_code
            "></i>

          <!-- language name -->
          <span class="country-text">
            {{ lang?.language }}
          </span>
        </button>
      </li>
    }
  </ul>
</section>
